export const LOAD_MESSAGES = 'LOAD_MESSAGES';
export const LOAD_MESSAGES_SUCCESS = 'LOAD_MESSAGES_SUCCESS';
export const LOAD_MESSAGES_ERROR = 'LOAD_MESSAGES_ERROR';

export const SEND_MESSAGE = 'SEND_MESSAGE';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_ERROR = 'SEND_MESSAGE_ERROR';

export const SET_MESSAGES = 'SET_MESSAGES';
export const SET_LAST_MESSAGE = 'SET_LAST_MESSAGE';

export const SET_STREAMING = 'SET_STREAMING';

export const SET_INTERVAL_COUNTER = 'SET_INTERVAL_COUNTER';

export const SET_LIMIT_REACHED = 'SET_LIMIT_REACHED';

export const SET_LIMIT_MESSAGE = 'SET_LIMIT_MESSAGE';
export const SET_BUSY_MESSAGE = 'SET_BUSY_MESSAGE';

export const SET_SCROLL_TO_BOTTOM = 'SET_SCROLL_TO_BOTTOM';

export const FLAG_MESSAGE = 'FLAG_MESSAGE';
export const FLAG_MESSAGE_SUCCESS = 'FLAG_MESSAGE_SUCCESS';
export const FLAG_MESSAGE_ERROR = 'FLAG_MESSAGE_ERROR';

export const CLEAN_MESSAGES_STORE = 'CLEAN_MESSAGES_STORE';
